import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-italic",
  "use": "icon-italic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-italic\"><path d=\"M897.948071 61.745273l0 64.321958L769.298885 126.06723 447.675918 897.933793l128.649186 0 0 64.320934-450.273176 0 0-64.320934 128.65021 0 321.622966-771.865539L447.675918 126.068254 447.675918 61.745273 897.948071 61.745273z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol